import { AuthTokenResponse } from 'app/api/model/AuthTokenResponse';
import { AuthInfo } from 'app/pages/auth/model/auth-info';

export class AuthInfoMapper {
    public static toAuthInfo(authTokenResponse: AuthTokenResponse): AuthInfo {
        return {
            accessToken: authTokenResponse.access_token,
            refreshToken: authTokenResponse.refresh_token,
            idToken: authTokenResponse.id_token,
            expiresIn: authTokenResponse.expires_in,
            tokenType: authTokenResponse.token_type,
        };
    }
}
